import React, { useEffect, useState, } from 'react';
import '../admin.list.scss';
import { useTranslation, } from 'react-i18next';
import { useNavigate, } from 'react-router-dom';
import { ColumnsType, SorterResult, } from 'antd/lib/table/interface';
import { IPreviewStatsCustomMetric, PermissionEnum, CrudEnum, TStatsCustomMetricSortableListCol, } from 'atlas-shared';
import { Table, } from 'antd';
import { AdminListPageHeader, ListPageEmpty, } from '@Components';
import { IWithListProps, IWithListSorterProps, withList, } from '@Hocs/with.list';
import { useAbilities, useAuth, useStatsCustomMetrics, useOrganizations, } from '@Hooks';
import { StatsCustomMetricListColumns, } from '@Utils';
import { IAuth, } from '@Store';

const StatsCustomMetricList = ({ filters, filtersCount, hasFilters, sorter, pagination, setQueryParams, resetQueryParams, }: IWithListProps<IPreviewStatsCustomMetric, TStatsCustomMetricSortableListCol>) => {
  const { t, } = useTranslation();
  const navigate = useNavigate();
  const auth: IAuth = useAuth();
  const stats_custom_metrics = useStatsCustomMetrics();
  const abilities = useAbilities();
  const [loading, setLoading, ] = useState<boolean>(true);
  const [rows, setRows, ] = useState<Array<any>>([]);
  const organizations = useOrganizations();
  
  const [showDeleted, setShowDeleted, ] = useState(false);
  const [deletedCount, setDeletedCount, ] = useState<number>(0);
  
  useEffect(() => {
    if (!stats_custom_metrics.loaded)
      return;
      
    setLoading(false);
    setRows((!showDeleted ? stats_custom_metrics.stats_custom_metrics.filter(p => !p.deleted_at) : stats_custom_metrics.stats_custom_metrics || []).map(row => ({ ...row, key: row.id, })));
    setDeletedCount(stats_custom_metrics.stats_custom_metrics.filter(stats_custom_metric => !!stats_custom_metric.deleted_at).length);
  }, [stats_custom_metrics, showDeleted, ]);

  const columns: ColumnsType<IPreviewStatsCustomMetric> = React.useMemo(() => {
    return StatsCustomMetricListColumns(t, navigate, showDeleted, organizations, abilities, auth, [], filters, sorter);
  }, [t, navigate, showDeleted, organizations, abilities, auth, filters, sorter, ]);

  return <div className='admin-list-view'>
    <AdminListPageHeader 
      t={t}
      title={t('STATS_CUSTOM_METRICS')}
      filtersCount={filtersCount}
      reset={() => resetQueryParams()}
      deleted={[showDeleted, setShowDeleted, ]} deletedCount={deletedCount}
      addBtn={abilities.canImplicit(null, CrudEnum.Insert, PermissionEnum.StatsCustomMetric) ? { callback: () => navigate('/admin/stats_custom_metric/add'), } : undefined} 
    />
    <div className='table-wrp'>
      <Table
        key={loading ? 1 : 0}
        columns={columns}
        dataSource={rows}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
        }}
        onChange={(pagination, filters, _sorter) => {
          const sorter: Array<SorterResult<any>> = Array.isArray(_sorter) ? _sorter : _sorter?.columnKey ? [_sorter, ] : [];

          setQueryParams({
            pagination: { current: pagination.current as number, pageSize: pagination.pageSize as number, },
            filters: Object.fromEntries(Object.entries(filters).filter(([key, value, ]) => value !== null)),
            sorter: sorter
              .filter(s => !!s.order)
              .map(s => ({ column: s.columnKey as TStatsCustomMetricSortableListCol, order: s.order as IWithListSorterProps<IPreviewStatsCustomMetric, TStatsCustomMetricSortableListCol>['order'], })),
          });
        }}
        locale={{
          emptyText: <ListPageEmpty t={t} hasFilters={hasFilters} hasRows={!!rows.length} reset={() => resetQueryParams()} />,
        }}
      />
    </div>
  </div>;
};

export const StatsCustomMetricListView = React.memo(withList<IPreviewStatsCustomMetric, TStatsCustomMetricSortableListCol>(StatsCustomMetricList, {
  filters: {},
  sorter: [{ column: 'created_at', order: 'descend', }, ],
  pagination: { current: 1, pageSize: 10, },
}));
